import authApi from '../authApi';
import { FormDataConfig } from '../config';
import { addCountryCode } from '../contryCode';
import { getFileFromS3 } from '../S3/s3Api';

// 계정에 연결된 도장 리스트
export const selectDojang = async () => {
  const res = await authApi.get('dojang/dojangselect');
  return res.data;
};

// 도장 삭제 (수정 : TB_DOJANG ==> IS_ALIVE : 0)
export const deleteDojang = async (body) => {
  const res = await authApi.post('dojang/dojangdelete', body);
  return res.data;
};

// 도장 정보 (수정 get -> post)
export const getDojangInfo = async (body) => {
  const fullBody = addCountryCode(body);
  const res = await authApi.post('dojang/dojangread', fullBody);
  return res.data;
};

export const getDojangInfoforUpdate = async (body) => {
  const fullBody = addCountryCode(body);
  const { data } = await authApi.post('dojang/dojangread', fullBody);
  const brPromise = data?.BR_IMG && (await getFileFromS3(data?.BR_IMG, 'business_cert'));
  const logoPromise = data?.LOGO_IMG && (await getFileFromS3(data?.LOGO_IMG, 'logo'));
  const signPromise = data?.SIGNATURE_IMG && (await getFileFromS3(data?.SIGNATURE_IMG, 'seal'));
  const [brFile, logoFile, signFile] = await Promise.all([brPromise, logoPromise, signPromise]);

  return {
    ...data,
    br: brFile,
    logo: logoFile,
    sign: signFile,
  };
};

export const getDojangList = async (body) => {
  const fullBody = addCountryCode(body);
  const res = await authApi.post('dojang/dojangread', fullBody);
  return res.data;
};

// 도장 생성(수정)
export const createDojang = async (body) => {
  const res = await authApi.post('dojang/dojangcreate', body, FormDataConfig);
  return res.data;
};

// 도장 수정(수정)
export const updateDojangInfo = async (body) => {
  const res = await authApi.post('dojang/dojangupdate', body, FormDataConfig);
  return res.data;
};

// 수정(get -> post)
export const ByMonth = async (body) => {
  const res = await authApi.post('dojang/dojang_home_schedule', body);
  return res.data;
};

export const getDojangPaymentInfo = async (dojangId) => {
  // const res = await authApi.get(`/pay`)
  // return res.data
  return;
};

// 급 / 띠 조회 (수정 get -> post)
export const getDojangLevelList = async (body) => {
  const res = await authApi.post('dojang/levelinforead', body);
  return res.data;
};

// 급 / 띠 수정 (수정 formData X)
export const updateDojangLevelList = async (body) => {
  const res = await authApi.post('dojang/levelinfoupdate', body);
  return res.data;
};

// pid 정보 (수정 get -> post)
export const getPidInfo = async (body) => {
  const res = await authApi.post('dojang/pid_read', body);
  return res.data;
};

// pid 수정 (수정)
export const updatePidInfo = async (body) => {
  const res = await authApi.post('dojang/pid_create', body);
  return res.data;
};

// 도장 결제정보
export const getDojangBillInfo = async (body) => {
  const res = await authApi.post('dojang/billread', body);
  return res.data;
};

// 결제선생 사업자 등록 url
export const getPayssamInfo = async (body) => {
  const res = await authApi.post('pay/reg_member', body);
  return res.data;
};

// 도장 청구서 신청(서비스 신청 && 연장)
export const dojangBillRegist = async (body) => {
  const res = await authApi.post('pay/bill/dj_send', body);
  return res.data;
};

// 도장 청구서 신청(서비스 신청 && 연장)
export const dojangBillChange = async (body) => {
  const res = await authApi.post('pay/ch_dj_billplan', body);
  return res.data;
};

// 도장 청구서 재발행
export const dojangBillResend = async (body) => {
  const res = await authApi.post('pay/bill/resend', body);
  return res.data;
};

export const dojangBillScheduler = async () => {
  const res = await authApi.post('test/4');
  return res.data;
};

// 문의 사항
export const createInquiry = async (body) => {
  const res = await authApi.post('dojang/q_create', body);
  return res.data;
};

export const getBusOperationInfo = async (dojang_id) => {
  const res = await authApi.post('car/carread_simple', { dojang_id });
  return res.data?.car_info;
};

export const getTodayAttendanceInfo = async (dojang_id) => {
  const res = await authApi.post('student/attendancesreadbyday', { dojang_id });
  return res.data;
};

export const getDojangScheduleByMonth = async (dojang_id, year, month) => {
  const res = await authApi.post('dojang/schedulereadbymonth', { dojang_id, year, month });
  return res.data?.schedule_info;
};

export const getOverdueList = async (dojang_id) => {
  const res = await authApi.post('student/studentdelinquenrcyread', { dojang_id });
  return res.data;
};

//////////////////////////////////// VERSION 2 ///////////////////////////////////////

// 결제 선생 연동 여부 확인
export const getPayssamStatus = async (dojang_id) => {
  const res = await authApi.get(`/v2/dojang/payssam/preuser-registration-approval/${dojang_id}`);
  return res.data;
};

// 오늘의 출결 현황
export const getTodayAttendance = async (dojang_id, tz) => {
  const encodedTz = encodeURIComponent(tz);
  const res = await authApi.get(
    `v2/dojang/board/attendance-today-class-by-timezone/read/${dojang_id}?tz=${encodedTz}`,
  );
  return res.data;
};

// 홈페이지 정보
export const getDojangHomepageInfo = async (dojang_id) => {
  const res = await authApi.get(`v2/dojang/homepage-info/${dojang_id}`);
  return res.data;
};

// 급띠체계 US
export const getDojangLevelListUs = async (dojang_id) => {
  const res = await authApi.get(`v2/dojang/rank-system/us/${dojang_id}`);
  return res.data;
};

// 급띠체계 US 수정
export const updateDojangLevelListUs = async (dojang_id, body) => {
  const res = await authApi.post(`v2/dojang/rank-system/us/${dojang_id}`, body);
  return res.data;
};

// 도장정보 home
export const getDojangInfoUS = async (dojang_id) => {
  const res = await authApi.get(`v2/dojang/us/${dojang_id}`);
  return res.data;
};

// inquiry
export const setInquiry = async (dojang_id, body) => {
  const res = await authApi.post(`v2/dojang/inquiry/${dojang_id}`, body);
  return res.data;
};

// zipcode로 주소검색
export const searchAddress = async (zip) => {
  const res = await authApi.get(`v2/dojang/geocode?zip=${zip}`);
  return res.data;
};
